import React from 'react';

function Footer() {
  const ev = new Date().getFullYear();

  return (
    <footer style={{
      background: 'linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)',
      color: 'white',
      padding: '3rem 2rem 1.5rem',
      marginTop: 'auto',
    }}>
      <div style={{maxWidth: '1200px', margin: '0 auto'}}>

        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '2rem', marginBottom: '2.5rem'}}>

          <div>
            <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '1rem'}}>
              <img src="/NetOkos_log.png" alt="NetOkos logo" style={{height: '40px', filter: 'brightness(0) invert(1)'}}/>
              <span style={{fontSize: '22px', fontWeight: '800', letterSpacing: '1px'}}>NetOkos</span>
            </div>
            <p style={{fontSize: '14px', color: 'rgba(255,255,255,0.75)', lineHeight: '1.7', maxWidth: '260px'}}>
              Tanulj. Védj. NetOkos Légy. Az internet biztonságos használatának elsajátítása játékos módon, 6-14 éves gyerekeknek.
            </p>
            <div style={{display: 'flex', gap: '12px', marginTop: '1.2rem'}}>
              {[
                { nev: 'Facebook', kep: '/facebook.png', link: 'https://www.facebook.com/profile.php?id=61590190689459' },
              ].map((s) => (
                <a key={s.nev} href={s.link} title={s.nev} target="_blank" rel="noopener noreferrer"
                  style={{background: 'white', borderRadius: '10px', width: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', textDecoration: 'none', transition: 'all 0.2s', padding: '6px', boxSizing: 'border-box'}}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 4px 14px rgba(0,0,0,0.25)'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}>
                  <img src={s.kep} alt={s.nev} style={{width: '100%', height: '100%', objectFit: 'contain'}}/>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 style={{fontSize: '16px', fontWeight: '700', marginBottom: '1rem', color: 'rgba(255,255,255,0.95)'}}>Tartalom</h3>
            <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
              {[
                { nev: '🧒 6-8 éves leckék', link: '/tanulas' },
                { nev: '🕵️ 9-11 éves leckék', link: '/tanulas' },
                { nev: '🤖 12-14 éves leckék', link: '/tanulas' },
                { nev: '👨‍👩‍👧 Szülőknek', link: '/szuloknek' },
              ].map((l) => (
                <a key={l.nev} href={l.link}
                  style={{color: 'rgba(255,255,255,0.75)', textDecoration: 'none', fontSize: '14px', transition: 'color 0.2s', display: 'flex', alignItems: 'center', gap: '6px'}}
                  onMouseEnter={e => e.currentTarget.style.color = 'white'}
                  onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.75)'}>
                  {l.nev}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 style={{fontSize: '16px', fontWeight: '700', marginBottom: '1rem', color: 'rgba(255,255,255,0.95)'}}>Hasznos linkek</h3>
            <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
              <a href="/fogalmak"
                style={{color: 'rgba(255,255,255,0.75)', textDecoration: 'none', fontSize: '14px', transition: 'color 0.2s'}}
                onMouseEnter={e => e.currentTarget.style.color = 'white'}
                onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.75)'}>
                🛡️ Kibervédelmi tippek
              </a>

              <a href="/segelyvonalak" target="_blank" rel="noopener noreferrer"
                style={{color: 'rgba(255,255,255,0.75)', textDecoration: 'none', fontSize: '14px', transition: 'color 0.2s'}}
                onMouseEnter={e => e.currentTarget.style.color = 'white'}
                onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.75)'}>
                📞 Segélyvonalak
              </a>

              <a href="/adatkezeles" target="_blank" rel="noopener noreferrer"
                style={{color: 'rgba(255,255,255,0.75)', textDecoration: 'none', fontSize: '14px', transition: 'color 0.2s'}}
                onMouseEnter={e => e.currentTarget.style.color = 'white'}
                onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.75)'}>
                🔒 Adatvédelmi szabályzat
              </a>

              <a href="/aszf" target="_blank" rel="noopener noreferrer"
                style={{color: 'rgba(255,255,255,0.75)', textDecoration: 'none', fontSize: '14px', transition: 'color 0.2s'}}
                onMouseEnter={e => e.currentTarget.style.color = 'white'}
                onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.75)'}>
                📄 ÁSZF
              </a>

              <a href="/partnereink" target="_blank" rel="noopener noreferrer"
                style={{color: 'rgba(255,255,255,0.75)', textDecoration: 'none', fontSize: '14px', transition: 'color 0.2s'}}
                onMouseEnter={e => e.currentTarget.style.color = 'white'}
                onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.75)'}>
                🤝 Partnereink
              </a>
            </div>
          </div>

          <div>
            <h3 style={{fontSize: '16px', fontWeight: '700', marginBottom: '1rem', color: 'rgba(255,255,255,0.95)'}}>Kapcsolat</h3>
            <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
              {[
                { ikon: '📧', szoveg: 'info.netokos@gmail.com' },
              ].map((k) => (
                <div key={k.szoveg} style={{display: 'flex', alignItems: 'center', gap: '10px', fontSize: '14px', color: 'rgba(255,255,255,0.75)'}}>
                  <span style={{fontSize: '18px'}}>{k.ikon}</span>
                  <span>{k.szoveg}</span>
                </div>
              ))}
            </div>

           
          </div>

        </div>

        <div style={{borderTop: '1px solid rgba(255,255,255,0.15)', paddingTop: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem'}}>
          <p style={{fontSize: '13px', color: 'rgba(255,255,255,0.6)', margin: 0}}>
            © {ev} NetOkos. Minden jog fenntartva. 🛡️ Biztonságos internet gyerekeknek.
          </p>
       
        </div>

      </div>
    </footer>
  );
}

export default Footer;